import React from "react";
import classnames from "classnames";
import styles from "./PreviewDot.module.scss";

interface Props {
  className?: string;
}

function PreviewDot({ className }: Props) {
  return <span className={classnames(styles.dot, className)} />;
}

export function PreviewLegend({ className }: Props) {
  return (
    <span className={classnames(styles.legend, className)}>
      <PreviewDot />
      Preview
    </span>
  );
}

export default PreviewDot;
